import { call, takeLatest } from "redux-saga/effects";
import * as resourceApi from "../apis/resourceApi";
import { ADD_GLOSSARY, DELETE_GLOSSARY, GLOSSARY_LIST, TM_DELETE, TM_ENABLE_DISABLE, TM_EXPORT, TM_LIST, UPLOAD_GLOSSARY_FILE } from "../actions/types";

export function* addGlossaryWorker(action) {
    try {
        const res = yield call(resourceApi.addGlossaryApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* listGlossaryWorker(action) {
    try {
        const res = yield call(resourceApi.glossaryListApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* deleteGlossaryWorker(action) {
    try {
        const res = yield call(resourceApi.deleteGlossaryApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* uploadGlossaryFileWorker(action) {
    try {
        const file = new FormData();
        file.append("file", action.file);
        const res = yield call(resourceApi.uploadGlossaryFileApi, file);

        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}



export function* listTranslationMemoryWorker(action) {
    try {
        const res = yield call(resourceApi.translationMemoryListApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* deleteTranslationMemoryWorker(action) {
    try {
        const res = yield call(resourceApi.deleteTranslationMemoryApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* enableDisableTranslationMemoryWorker(action) {
    try {
        const res = yield call(resourceApi.enableDisableTranslationMemoryApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* exportTranslationMemoryWorker(action) {
    try {
        const res = yield call(resourceApi.exportTranslationMemoryApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

/* Watcher Function*/

export function* addGlossaryWatcher() {
    yield takeLatest(ADD_GLOSSARY, addGlossaryWorker);
}

export function* deleteGlossaryWatcher() {
    yield takeLatest(DELETE_GLOSSARY, deleteGlossaryWorker);
}

export function* listGlossaryWatcher() {
    yield takeLatest(GLOSSARY_LIST, listGlossaryWorker);
}

export function* uploadGlossaryFileWatcher() {
    yield takeLatest(UPLOAD_GLOSSARY_FILE, uploadGlossaryFileWorker);
}

export function* listTranslationMemoryWatcher() {
    yield takeLatest(TM_LIST, listTranslationMemoryWorker);
}

export function* deleteTranslationMemoryWatcher() {
    yield takeLatest(TM_DELETE, deleteTranslationMemoryWorker);
}

export function* enableDisableTranslationMemoryWatcher() {
    yield takeLatest(TM_ENABLE_DISABLE, enableDisableTranslationMemoryWorker);
}

export function* exportTranslationMemoryWatcher() {
    yield takeLatest(TM_EXPORT, exportTranslationMemoryWorker);
}